Auth = require 'db/auth'
ClientConfig = require 'debug/client-config'
trackGoogleTagManager = require 'debug/trackGoogleTagManager'

window.sp? 'newTracker', 'cf', window.snowplowCloudfrontServer,
  appId: ClientConfig.get('appId') or 'web'
  cookieDomain: '.trello.com'
  respectDoNotTrack: true

if Auth.isLoggedIn()
  window.sp?('setUserId', Auth.myId())
  trackGoogleTagManager.push isLoggedIn: true
else
  trackGoogleTagManager.push isLoggedIn: false

window.dataLayer?.push inApp: true
window.sp? ->
  trackGoogleTagManager.push
    event: 'snowplow.loaded'
    snowplow:
      domain_userid: this.cf?.getDomainUserId()



// WEBPACK FOOTER //
// ./app/scripts/entry/init-analytics.coffee